export default __webpack_public_path__ + "static/media/06-microcities.d2c27a09.mp4";